// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__kmMK9","wrapper":"LoginPage_wrapper__SyXqp","header":"LoginPage_header__J2UYH","divider":"LoginPage_divider__tCSIs"};